export const Marquee = ({ items, dark = false }) => {
  const row = items.map((item, i) => (
    <span key={i} className="flex shrink-0 items-center">
      <span className={`whitespace-nowrap font-serif text-2xl font-light italic tracking-wide sm:text-3xl ${dark ? "text-ivory/80" : "text-charcoal/70"}`}>
        {item}
      </span>
      <span className="mx-8 inline-block h-1.5 w-1.5 rotate-45 bg-champagne sm:mx-12" aria-hidden="true" />
    </span>
  ));
  return (
    <div
      data-testid="editorial-marquee"
      className={`relative overflow-hidden border-y py-6 sm:py-8 ${dark ? "border-white/10 bg-obsidian" : "border-warm-border bg-stone-beige"}`}
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee">
        <div className="flex shrink-0">{row}</div>
        <div className="flex shrink-0">{row}</div>
      </div>
    </div>
  );
};

export default Marquee;
